import Vue from 'vue'
import store from '@/store/'
import {
  SAVE_SEARCH_BY_TAXID
} from '@/store/mutation-types'

export default function Initializer () {
  store.dispatch('organization/init', Vue.ls.get(SAVE_SEARCH_BY_TAXID))
}



// WEBPACK FOOTER //
// ./src/core/bootstrap.js